export { default } from './Divider';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Divider/index.js
// module id = 320
// module chunks = 0